import styled from '@emotion/styled';

import {
  spacing,
  borderRadius,
  typography,
  transitions,
  colors,
} from '../tokens';

/**
 * Mesma paleta do Input (pill), mas o container é um retângulo arredondado
 * (textarea multilinha). Calibrar com o Figma quando a cota da API resetar.
 */
const spec = {
  border: '#595959',
  borderFocus: '#3D3D3D',
  borderDisabled: '#D9D9D9',
  text: '#3D3D3D',
  placeholder: '#8C8C8C',
};

// ─── Campo com rótulo ─────────────────────────────────────────────────────────

export const FieldRoot = styled('div', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<{ $fullWidth: boolean }>`
  display: ${({ $fullWidth }) => ($fullWidth ? 'flex' : 'inline-flex')};
  flex-direction: column;
  gap: ${spacing.sm};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
`;

export const FieldLabel = styled('label')`
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.md};
  font-weight: ${typography.fontWeight.regular};
  color: #3d3d3d;
`;

export const RequiredMark = styled('span')`
  color: ${colors.error};
`;

// ─── Container + textarea ─────────────────────────────────────────────────────

export const TextareaWrapper = styled('div', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<{ $disabled: boolean; $fullWidth: boolean; $error?: boolean }>`
  display: ${({ $fullWidth }) => ($fullWidth ? 'flex' : 'inline-flex')};
  box-sizing: border-box;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  padding: ${spacing.lg} ${spacing.xl};
  background-color: #ffffff;
  border: 1px solid
    ${({ $disabled, $error }) => {
      if ($error) return colors.error;
      return $disabled ? spec.borderDisabled : spec.border;
    }};
  border-radius: ${borderRadius.xl};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  transition: border-color ${transitions.base};

  &:focus-within {
    border-color: ${({ $error }) => ($error ? colors.error : spec.borderFocus)};
  }
`;

export const StyledTextarea = styled('textarea')`
  flex: 1;
  min-width: 0;
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  resize: vertical;
  font-family: ${typography.fontFamily.primary};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.regular};
  line-height: 1.5;
  color: ${spec.text};

  &::placeholder {
    color: ${spec.placeholder};
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
